<template>
  <div class="scene-module scene-teach">
    <div class="overview-banner-wrapper">
      <div class="overview-banner-area w1168">
        <h1>教育领域</h1>
        <p v-if="$store.state.sceneClassName === 'app'">
          一站式解决教育行业招生、运营、<br />管理难题，打通线上线下教学场景，实<br />现数字化教培升级
        </p>
        <p v-else>
          一站式解决教育行业招生、运营、管理难题，<br />打通线上线下教学场景，实现数字化教培升级
        </p>
        <a href="/">立即创建体验</a>
      </div>
    </div>
    <div class="w1168 center pt96 teach-box-1">
      <div v-if="$store.state.sceneClassName !== 'app'" class="lz-title1">
        构建教培经营闭环，打通线上线下教学场景
      </div>
      <div class="problem">
        <img
          :src="require('@/assets/images/scenePic7.png')"
          class="problem-img"
        />
      </div>
    </div>
    <div v-if="$store.state.sceneClassName === 'app'" class="solution-app">
      <h2 class="title mb64">
        知链教育培训，助力<br />教育行业实现互联网转型升级
      </h2>
      <el-collapse v-model="onlineSchoolActive" accordion>
        <el-collapse-item
          v-for="(item, index) in onlineSchool"
          :key="`osh_${index}`"
          :title="item.nav"
          :name="index"
          ><div
            class="item-wrap"
            :style="{
              background: item.backgroundColor || '',
            }"
          >
            <h3 class="title">{{ item.title }}</h3>
            <p class="desc">{{ item.desc }}</p>
            <div class="img-box"><img :src="item.img" /></div>
            <div class="tip">{{ item.tip }}</div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div v-else class="solution pt96 pb96 w1168">
      <h2 class="lz-title1 mb64">让您一分钟拥有自己的在线网校</h2>
      <div class="online-school flex">
        <ul class="tab-head shrink0">
          <li
            v-for="(item, index) in onlineSchool"
            :key="`osh_${index}`"
            :style="{
              background:
                index === onlineSchoolActive ? item.backgroundColor : '',
            }"
            @mouseover="moduleSchoolOver(index)"
          >
            {{ item.nav }}
          </li>
        </ul>
        <div
          class="tab-content flex1"
          :style="{
            background: onlineSchool[onlineSchoolActive].backgroundColor,
          }"
        >
          <div class="text">
            <span class="topic">{{
              onlineSchool[onlineSchoolActive].title
            }}</span>
            <h2 class="title">{{ onlineSchool[onlineSchoolActive].sTitle }}</h2>
            <p class="desc">{{ onlineSchool[onlineSchoolActive].desc }}</p>
          </div>
          <div class="img bd-img">
            <img :src="onlineSchool[onlineSchoolActive].img" alt="" />
          </div>
          <div class="tip">{{ onlineSchool[onlineSchoolActive].tip }}</div>
        </div>
      </div>
    </div>
    <v-channel></v-channel>
    <div class="organizations pt72 pb80 w1168">
      <div class="lz-title1 mb72">
        适用于以下或更多教育<br
          v-if="$store.state.sceneClassName === 'app'"
        />培训行业
      </div>
      <ul>
        <li v-for="(item, index) in tradeArr" :key="`ta_${index}`">
          <div class="organizations-icon-div">
            <i :class="`organizations-icon iconfont ${item.iconType}`"></i>
          </div>
          <p>{{ item.title }}</p>
        </li>
      </ul>
    </div>
    <v-case-list></v-case-list>
    <v-free
      v-if="$store.state.sceneClassName === 'app'"
      title="一站式解决教育培训<br/>行业招生、运营、管理难题"
      href=""
    ></v-free>
    <v-free
      v-else
      title="一站式解决教育行业招生、运营、管理难题"
      href=""
    ></v-free>
  </div>
</template>

<script>
import Free from '@/components/Free';
import Channel from '@/components/Channel';
import CaseList from '@/components/CaseList';
import { onlineSchool, tradeArr } from './data';
export default {
  name: 'sceneTeach',
  data() {
    return {
      onlineSchool,
      tradeArr,
      onlineSchoolActive: 0
    };
  },
  components: {
    'v-free': Free,
    'v-channel': Channel,
    'v-case-list': CaseList
  },
  methods: {
    moduleSchoolOver(index) {
      this.onlineSchoolActive = index;
    }
  }
};
</script>

<style lang="scss">
.scene-teach {
  .overview-banner-wrapper {
    background-image: url('~@/assets/images/sceneBanner1.jpg');
  }
  .online-school {
    height: 900px;
    .tab-head {
      width: 140px;
      border-bottom: 1px solid #eee;
      overflow: hidden;
      box-sizing: border-box;
      li {
        height: 75px;
        line-height: 75px;
        font-size: 16px;
        color: #333;
        cursor: pointer;
        text-align: center;
        border: 1px solid #eee;
        border-right: 0;
        border-bottom: 0;
        &.on {
          color: #1472ff;
          background: linear-gradient(#f9fdff, #f3f6fc);
        }
      }
    }
    .tab-content {
      position: relative;
      padding: 64px 100px 40px;
      height: 900px;
      .text {
        text-align: center;
      }
      .topic {
        position: relative;
        color: #5f6e8e;
        font-size: 20px;
        margin-bottom: 44px;
        display: inline-block;
        border-bottom: 2px solid #1472ff;
      }
      .title {
        color: #333;
        font-size: 28px;
        margin-bottom: 18px;
        font-weight: 500;
      }
      .desc {
        width: 728px;
        margin: 0 auto 24px;
        color: #333;
        line-height: 24px;
      }
      .bd-img img {
        max-width: 806px;
      }
      .tip {
        position: absolute;
        bottom: 80px;
        color: #b2b2b2;
      }
      .desc,
      .tip {
        font-size: 12px;
        font-weight: 400;
      }
    }
  }

  .organizations {
    text-align: center;
  }
  .organizations ul {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0 32px;
  }
  .organizations ul li .organizations-icon-div {
    width: 56px;
    height: 56px;
    margin: 0 auto;
    background: #f2f7ff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
  }
  .organizations ul li .organizations-icon-div .organizations-icon {
    font-size: 35px;
    color: #1472ff;
  }
  .organizations ul li p {
    font-size: 14px;
    color: #333;
    line-height: 30px;
    margin-top: 8px;
  }
}
.app {
  .scene-teach {
    .overview-banner-wrapper {
      height: 8.64rem;
      background-color: #1472ff;
      background-image: url('~@/assets/images/sceneBanner1_app.png');
      background-position: center;
      background-position-y: -0.96rem;
      background-size: cover;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0.96rem 0.32rem 0;
      margin-top: 1.04rem;
      text-align: center;
      h1 {
        margin: 0;
        font-size: 0.8rem;
        font-weight: 600;
        color: #fff;
        line-height: 0.88rem;
      }
      p {
        margin-top: 0.24rem;
        margin-bottom: 0.4rem;
        font-size: 0.32rem;
        font-weight: 400;
        color: #fff;
        line-height: 0.48rem;
        width: 5.6rem;
      }
      a {
        border: none;
        outline: 0;
        margin: 0 auto;
        width: 3.2rem;
        height: 0.8rem;
        background: #fff;
        border-radius: 0.88rem;
        font-size: 0.32rem;
        font-weight: 500;
        color: #1472ff;
        line-height: 0.8rem;
        text-align: center;
      }
    }
    .teach-box-1 {
      padding: 1.28rem 0;
    }
    .problem-img {
      width: 100%;
    }
    .solution-app {
      .title {
        text-align: center;
        font-size: 0.4rem;
        line-height: 0.56rem;
        margin-bottom: 0.96rem;
      }
    }
    .case-list {
      background: #ffffff;
    }
    .solution-app {
      .el-collapse-item__header {
        height: 1.08rem;
        line-height: 1.08rem;
        border-top: 1px solid #d8d8d8;
        padding: 0 0.32rem;
        font-size: 0.32rem;
        cursor: pointer;
        position: relative;
        color: #1472ff;
      }
      .el-collapse-item__arrow {
        font-size: 0.28rem;
        color: #1472ff;
      }
      .el-collapse-item__content {
        padding: 0;
        .item-wrap {
          background: linear-gradient(#f9fdff, #f3f6fc);
          padding: 0.8rem 0.32rem;
          .title {
            line-height: 0.56rem;
            margin-bottom: 0.24rem;
            font-size: 0.4rem;
            color: #353535;
          }
          .desc {
            color: #333;
            line-height: 0.48rem;
            margin-bottom: 0.32rem;
          }
          .img-box {
            margin: 0.8rem 0;
            position: relative;
            img {
              width: 100%;
              height: auto;
            }
          }
          .tip {
            font-size: 0.24rem;
            line-height: 0.36rem;
            color: #b2b2b2;
          }
        }
      }
    }
    .panorama-education-div {
      width: 100%;
      height: 13.8rem;
      background-color: #f5f6f9;
      .panorama-education {
        margin-top: 0;
      }
    }
    .organizations {
      padding: 1.6rem 0;
      ul {
        justify-content: normal;
        li {
          width: 33.3%;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 0.96rem;
          .organizations-icon-div {
            width: 1.2rem;
            height: 1.2rem;
            border-radius: 50%;
            margin-bottom: 0.24rem;
            background: #f2f7ff;
            display: flex;
            align-items: center;
            justify-content: center;
            i {
              font-size: 0.8rem;
            }
          }
          p {
            font-size: 0.3rem;
            color: #333;
            line-height: 0.44rem;
          }
        }
      }
    }
    .case-list {
      background: #f5f6f9;
    }
  }
}
</style>
